module.exports = __webpack_public_path__ + "assets/img/QDCCB.00e213e7.png";